import React from 'react';
import SupportForm from '../forms/SupportForm';
import '../styles/SupportPage.css';

const SupportPage = () => {
    return (
        <div className="support-page">
            <p>If you're experiencing issues with our app or have any questions, please fill out the form below and we'll get back to you as soon as possible.</p>
            <SupportForm />
        </div>
    );
};

export default SupportPage;
